import React from 'react';
import clsx from 'clsx';
import styles from './submitButton.module.css';
import { CircularProgress } from '@material-ui/core';

const SubmitButton = ({
  text,
  disable,
  onClick,
  loading,
  width,
  className,
}) => {
  return (
    <button
      className={clsx(
        styles.container,
        disable ? styles.disabled : '',
        className
      )}
      onClick={!disable ? onClick : undefined}
      disabled={disable}
      style={{ width: width }}>
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <span className={styles.text}>{text}</span>
      )}
    </button>
  );
};

export default SubmitButton;
